export interface DomEventSubscription {
  dispose();
}

export class EventListenerRegistration {
  constructor(element: any) {
    this._element = element;
  }

  private _element: any;

  scroll(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('scroll', handler);
  }

  resize(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('resize', handler);
  }

  click(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('click', handler);
  }

  postMessage(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('message', handler);
  }

  devicechanged(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('ondevicechanged', handler);

  }

  popstate(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('popstate', handler);
  }

  hardwareBackButton(handler: EventListenerOrEventListenerObject): DomEventSubscription {
    return this._subscribe('backbutton', handler);
  }

  unload = (handler: EventListenerOrEventListenerObject): DomEventSubscription => {
    // Why use "pagehide" instead of unload
    // https://dev.azure.com/888holdings/GamingNDL/_git/ff235275-fba4-4733-a4ee-b6fd0d1639bf/pullrequest/38438
    // https://web.dev/bfcache/?utm_source=lighthouse&utm_medium=lr#never-use-the-unload-event

    // Later we should switch to visibilityChange which covers even more cases, but it's not supported below Safari 14:
    // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/sendBeacon#sending_analytics_at_the_end_of_a_session
    return this._subscribe('pagehide', handler);
  }

  protected _subscribe = (eventName: string, handler: EventListenerOrEventListenerObject): DomEventSubscription => {
    this._element.addEventListener(eventName, handler);
    return {
      dispose: () => this._element?.removeEventListener(eventName, handler)
    }
  }

}
